export enum OUTLET_ENUMS {
    ALL_OUTLETS = 'all_outlets'
  }